import { css } from "styled-components";
import token from "styled-token";
import { mediaQueryMixin } from "../mediaQueryMixin";
import { inlineMediaQueryMixin } from "../inlineMediaQueryMixin";
import { typographyMixin } from "../typographyMixin";
import { StyledDialog } from "../../components/Dialog/Dialog";
import { StyledDialogActions } from "../../components/Dialog/DialogActions";
import { StyledDialogHeader } from "../../components/Dialog/DialogHeader";
import { StyledDialogBody } from "../../components/Dialog/DialogBody";
import { StyledDialogClose } from "../../components/Dialog/DialogClose";
import { StyledText } from "../../components/Text/Text";
import { StyledPopoverArrow } from "../../components/Popover/PopoverArrow";
import { StyledPopoverIcon } from "../../components/Popover/PopoverIcon";
import { DialogMixin } from "./DialogMixin";
import { ModalMixin } from "./ModalMixin";
import { spaceMixin } from "../spaceMixin";
import { overflowPaddingMixin } from "../overflowPaddingMixin";
import { overflowAutoMixin } from "../overflowAutoMixin";

var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;

  if (!appearance) {
    return "";
  }

  return token({
    background: "status." + appearance + ".background",
    foreground: "status." + appearance + ".foreground"
  }, function (tokens) {
    return css(["", "{background-color:", ";border-color:", ";}", "{color:", ";}&[data-popper-placement^=\"bottom\"] ", ":after{background-color:", ";}"], StyledDialogHeader, tokens.background, tokens.background, StyledPopoverIcon, tokens.foreground, StyledPopoverArrow, tokens.background);
  })(props);
};

var iconCSS = function iconCSS(props) {
  if (!props.icon) {
    return "";
  }

  return token({
    iconSize: "icons.sizes.sm",
    padding: "Popover.padding"
  }, function (_ref) {
    var iconSize = _ref.iconSize,
        padding = _ref.padding;
    return css(["", "{position:absolute;top:", "px;left:", "px;}", "{padding-left:", "px;}"], StyledPopoverIcon, padding, padding, StyledDialogHeader, spaceMixin("xs", function (space) {
      return space.value + padding + iconSize;
    })(props));
  })(props);
};

var arrowCSS = token("Popover.arrowOuterSize", function (arrowOuterSize) {
  return css(["", "{position:absolute;display:block;}&[data-popper-placement^=\"top\"] ", "{bottom:-", "px;}&[data-popper-placement^=\"right\"] ", "{left:-", "px;}&[data-popper-placement^=\"bottom\"] ", "{top:-", "px;}&[data-popper-placement^=\"left\"] ", "{right:-", "px;}"], StyledPopoverArrow, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize, StyledPopoverArrow, arrowOuterSize);
});

var dialogCSS = function dialogCSS(props) {
  return token({
    zIndex: "zIndices.popover",
    borderRadius: "radii.md",
    maxWidth: "Dialog.maxWidth",
    maxHeight: "Popover.maxHeight",
    padding: "Popover.padding",
    separatorColor: "Popover.separatorColor",
    headingFontType: "Popover.headingFontType",
    backgroundColor: "Dialog.backgroundColor"
  }, function (_ref2) {
    var zIndex = _ref2.zIndex,
        borderRadius = _ref2.borderRadius,
        maxWidth = _ref2.maxWidth,
        maxHeight = _ref2.maxHeight,
        padding = _ref2.padding,
        separatorColor = _ref2.separatorColor,
        headingFontType = _ref2.headingFontType,
        backgroundColor = _ref2.backgroundColor;
    return css(["", " z-index:", ";display:flex;flex-direction:column;border-radius:", "px;width:100%;max-width:", "px;max-height:", "px;", "{padding:", "px;border-bottom:1px solid ", ";", "{", "}}", "{padding-top:", "px;}", "{", " ", " _:-ms-fullscreen &,&{flex-basis:150px;}}transform:translate3d(0,0,0);&:after{content:\"\";position:absolute;left:", "px;right:", "px;bottom:0;height:", "px;background:linear-gradient( 180deg,rgba(255,255,255,0) 0%,", " 100% );}", "{right:", "px;top:", "px;}", " ", " ", ""], DialogMixin(props), zIndex, borderRadius, maxWidth, maxHeight, StyledDialogHeader, padding, separatorColor, StyledText, typographyMixin(Object.assign({
      fontType: headingFontType
    }, props)), StyledDialogActions, padding, StyledDialogBody, overflowAutoMixin(props), overflowPaddingMixin(padding + "px", padding + "px", padding + "px")(props), padding, padding, padding, backgroundColor, StyledDialogClose, padding, padding, appearanceCSS(props), arrowCSS(props), iconCSS(props));
  })(props);
};

var modalCSS = inlineMediaQueryMixin("modal", function (mediaProps) {
  if (!mediaProps.modal) {
    return "";
  }

  return css(["", " > ", "{transform:none !important;position:relative !important;> ", "{display:none;}}"], ModalMixin(mediaProps), StyledDialog, StyledPopoverArrow);
});

var popoverCSS = function popoverCSS(props) {
  return css(["> ", "{", "}", ""], StyledDialog, dialogCSS(props), modalCSS(props));
};
/** @class PopoverMixin */

/** @method */


export var PopoverMixin = function PopoverMixin(props) {
  return [popoverCSS(props), mediaQueryMixin(function (mediaProps) {
    return popoverCSS(Object.assign({}, props, mediaProps));
  })];
};